import { log } from '../engine/log-sidecar'
import { soundsGeneric } from '../engine/soundsGeneric-sidecar'
import { IEnemyType } from './deathPunch'
let doPlayLoaded = false
let soundTest = false

let _musicPath = ''
const logNamespace = 'sounds'
export function load(audioJson: any, musicPath: string) {
  _musicPath = musicPath + '/'
  soundsGeneric.load(audioJson, () => {
    log.x(logNamespace, 'loaded')
    if (doPlayLoaded) {
      // playLoaded()
    }
    if (soundTest) {
      setInterval(() => {
        // playLoaded()
      }, 500)
    }
  })
  playMusic1()
}

let masterVolume = 0.75

export function stopSound(id: number) {
  if (id) {
    soundsGeneric.stopSound(id)
  }
}

export function playIntro() {
  let id = soundsGeneric.playWithChannel('intro', 0, masterVolume)
  soundsGeneric.loopSound(id)
  return id
}

export function playDied() {
  let id = soundsGeneric.playWithChannel('died', 0, masterVolume)
  return id
}
export function playBegin() {
  let id = soundsGeneric.playWithChannel('begin', 0, masterVolume)
  return id
}

export function playSmash() {
  //soundsGeneric.playWithChannel('smash001', -1)
}

export function playHurt(channel: number) {
  // soundsGeneric.playWithRandomRate('hurt001')
  soundsGeneric.playWithChannel('hurt001', channel, masterVolume)
}

export function playHit(channel: number) {
  // soundsGeneric.playWithRandomRate('hurt001')
  soundsGeneric.playWithChannel('impact_b', channel, masterVolume)
}
export function playMiss(channel: number) {
  // soundsGeneric.playWithRandomRate('hurt001')
  soundsGeneric.playWithChannel('swing', channel, masterVolume)
}
export function playError(channel: number) {
  // soundsGeneric.playWithRandomRate('hurt001')
  soundsGeneric.playWithChannel('error', channel, masterVolume)
}
export function playFivePoint() {
  // soundsGeneric.playWithRandomRate('hurt001')
  soundsGeneric.playWithChannel('jelly', 0, masterVolume)
}
export function playPoint() {
  // soundsGeneric.playWithRandomRate('hurt001')
  soundsGeneric.playWithChannel('pickup002', 0, masterVolume)
}

// export function playAttack(channel: number) {
//   soundsGeneric.playWithChannel('hurt001', channel, masterVolume)
// }
export function playMusic1() {
  // need new!
  console.log('playing music from', _musicPath)
  soundsGeneric.playMusic(_musicPath + 'the-fall', true, null, 0.1)
}
export function playFootsteps(
  channel: number,
  volume: number,
  monsterType: IEnemyType,
) {
  let file = 'snake'
  if (monsterType === 'shriek') {
    file = 'shriek'
  }
  if (monsterType === 'foots') {
    file = 'disarm_b_edited'
  }

  return soundsGeneric.playWithChannel(file, channel, volume * masterVolume)
}

export function playGameover() {
  soundsGeneric.playWithChannel('slowdown001', 0, masterVolume)
}

// export function play(soundName: string) {
//   soundsGeneric.play(soundName)
// }
